// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table__title {
  font-size: 3rem;
  padding-bottom: 2.5rem;
  margin-bottom: 2.5rem;
  min-width: 30%;
}
@media (max-width: 1679px) {
  .custom-table__title {
    font-size: 2.4rem;
    padding-bottom: 2.5rem;
    margin-bottom: 2rem;
  }
}
@media (max-width: 1368px) {
  .custom-table__title {
    font-size: 2rem;
    padding-bottom: 1.5rem;
    margin-bottom: 1.5rem;
  }
}
@media (max-width: 575px) {
  .custom-table__title {
    font-size: 1.8rem;
  }
}
.custom-table__table.table {
  --bs-table-bg: transparent;
  white-space: nowrap;
}
.custom-table__table.table thead {
  border: none;
}
.custom-table__table.table thead tr th {
  font-size: 1.6rem;
  padding: 1rem 2rem;
  font-weight: 500;
  border: none;
  color: #727272;
}
@media (max-width: 1679px) {
  .custom-table__table.table thead tr th {
    font-size: 1.4rem;
  }
}
@media (max-width: 575px) {
  .custom-table__table.table thead tr th {
    font-size: 1.2rem;
  }
}
.custom-table__table.table tbody tr {
  border-bottom: 0.1rem solid #252525;
}
.custom-table__table.table tbody td {
  white-space: nowrap;
  padding: 1.9rem 2rem;
  font-size: 2rem;
  vertical-align: middle;
  border-bottom: 0;
  min-width: 18rem;
  color: #ffffff;
}
@media (max-width: 1679px) {
  .custom-table__table.table tbody td {
    padding: 1.5rem 2rem;
    font-size: 1.8rem;
  }
}
@media (max-width: 1368px) {
  .custom-table__table.table tbody td {
    padding: 1rem 2rem;
    font-size: 1.6rem;
  }
}
@media (max-width: 575px) {
  .custom-table__table.table tbody td {
    font-size: 1.4rem;
  }
}
.custom-table__table.table tbody td.completed {
  color: #59ac0f;
}
.custom-table__table.table tbody td.pending {
  color: #fde076;
}
.custom-table__table.table tbody td.cancel {
  color: #c3292d;
}
.custom-table__table.table tbody tr.no_record td {
  padding: 1.5rem 0;
}
.custom-table__table.table tbody tr.no_record td .no_record_box {
  border-radius: 1.6rem;
  padding: 6rem 2rem;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) -29.92%, #161616 97.38%);
}
.custom-table__table.table tbody tr.no_record td .no_record_box h4 {
  font-size: 2rem;
  font-weight: 400;
  margin-top: 1.5rem;
}
@media (max-width: 1368px) {
  .custom-table__table.table tbody tr.no_record td .no_record_box h4 {
    font-size: 1.6rem;
  }
}
@media (max-width: 991px) {
  .custom-table__table.table tbody tr.no_record td .no_record_box {
    padding: 4rem 2rem;
  }
}
.custom-table__table.table th:first-child,
.custom-table__table.table td:first-child {
  padding-left: 0;
}
.custom-table__table.table th:last-child,
.custom-table__table.table td:last-child {
  padding-right: 0;
}
.custom-table__table.table .token-icon {
  display: inline-table;
  width: 3.6rem;
  height: 3.6rem;
  margin-right: 1rem;
  border-radius: 50%;
  overflow: hidden;
}
@media (max-width: 1368px) {
  .custom-table__table.table .token-icon {
    width: 3rem;
    height: 3rem;
  }
}
.custom-table__table.table .token-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.custom-table__pagination {
  padding-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #a3a3a3;
}
@media (max-width: 767px) {
  .custom-table__pagination {
    padding-top: 1.5rem;
    flex-direction: column-reverse;
    gap: 1.5rem;
  }
}

.common_table {
  color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/Components/UI/Table/CustomTable.scss","webpack://./src/Assets/Theme/_var.scss"],"names":[],"mappings":"AAGE;EACE,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AADJ;AAEI;EALF;IAMI,iBAAA;IACA,sBAAA;IACA,mBAAA;EACJ;AACF;AAAI;EAVF;IAWI,eAAA;IACA,sBAAA;IACA,qBAAA;EAGJ;AACF;AAFI;EAfF;IAgBI,iBAAA;EAKJ;AACF;AAFI;EACE,0BAAA;EACA,mBAAA;AAIN;AAFM;EACE,YAAA;AAIR;AADU;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cCtBC;ADyBb;AADY;EAPF;IAQI,iBAAA;EAIZ;AACF;AAHY;EAVF;IAWI,iBAAA;EAMZ;AACF;AAAQ;EACE,mCAAA;AAEV;AAAQ;EACE,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCtDF;ADwDR;AAAU;EATF;IAUI,oBAAA;IACA,iBAAA;EAGV;AACF;AADU;EAdF;IAeI,kBAAA;IACA,iBAAA;EAIV;AACF;AAHU;EAlBF;IAmBI,iBAAA;EAMV;AACF;AAFU;EACE,cAAA;AAIZ;AAFU;EACE,cAAA;AAIZ;AAFU;EACE,cAAA;AAIZ;AAEY;EACE,iBAAA;AAAd;AACc;EACE,qBAAA;EACA,kBAAA;EACA,2EC3DJ;AD4DZ;AACgB;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAClB;AACkB;EALF;IAMI,iBAAA;EAElB;AACF;AAAgB;EAdF;IAeI,kBAAA;EAGhB;AACF;AAMQ;;EACE,eAAA;AAHV;AAMQ;;EACE,gBAAA;AAHV;AAOM;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AALR;AAOQ;EARF;IASI,WAAA;IACA,YAAA;EAJR;AACF;AAKQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAHV;AASE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cC1IS;ADmIb;AASI;EAPF;IAQI,mBAAA;IACA,8BAAA;IACA,WAAA;EANJ;AACF;;AAUA;EACE,kBAAA;AAPF","sourcesContent":["@import \"../../../Assets/Theme/_var.scss\";\n\n.custom-table {\n  &__title {\n    font-size: 3rem;\n    padding-bottom: 2.5rem;\n    margin-bottom: 2.5rem;\n    min-width: 30%;\n    @media (max-width: 1679px) {\n      font-size: 2.4rem;\n      padding-bottom: 2.5rem;\n      margin-bottom: 2rem;\n    }\n    @media (max-width: 1368px) {\n      font-size: 2rem;\n      padding-bottom: 1.5rem;\n      margin-bottom: 1.5rem;\n    }\n    @media (max-width: 575px) {\n      font-size: 1.8rem;\n    }\n  }\n  &__table {\n    &.table {\n      --bs-table-bg: transparent;\n      white-space: nowrap;\n\n      thead {\n        border: none;\n\n        tr {\n          th {\n            font-size: 1.6rem;\n            padding: 1rem 2rem;\n            font-weight: 500;\n            border: none;\n            color: $secondary4;\n\n            @media (max-width: 1679px) {\n              font-size: 1.4rem;\n            }\n            @media (max-width: 575px) {\n              font-size: 1.2rem;\n            }\n          }\n        }\n      }\n\n      tbody {\n        tr {\n          border-bottom: 0.1rem solid $borderClr2;\n        }\n        td {\n          white-space: nowrap;\n          padding: 1.9rem 2rem;\n          font-size: 2rem;\n          vertical-align: middle;\n          border-bottom: 0;\n          min-width: 18rem;\n          color: $white;\n\n          @media (max-width: 1679px) {\n            padding: 1.5rem 2rem;\n            font-size: 1.8rem;\n          }\n\n          @media (max-width: 1368px) {\n            padding: 1rem 2rem;\n            font-size: 1.6rem;\n          }\n          @media (max-width: 575px) {\n            font-size: 1.4rem;\n          }\n\n          // status classes\n\n          &.completed {\n            color: #59ac0f;\n          }\n          &.pending {\n            color: #fde076;\n          }\n          &.cancel {\n            color: #c3292d;\n          }\n        }\n\n        tr {\n          &.no_record {\n            td {\n              padding: 1.5rem 0;\n              .no_record_box {\n                border-radius: 1.6rem;\n                padding: 6rem 2rem;\n                background: $gradient2;\n\n                h4 {\n                  font-size: 2rem;\n                  font-weight: 400;\n                  margin-top: 1.5rem;\n\n                  @media (max-width: 1368px) {\n                    font-size: 1.6rem;\n                  }\n                }\n                @media (max-width: 991px) {\n                  padding: 4rem 2rem;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      th,\n      td {\n        &:first-child {\n          padding-left: 0;\n        }\n\n        &:last-child {\n          padding-right: 0;\n        }\n      }\n\n      .token-icon {\n        display: inline-table;\n        width: 3.6rem;\n        height: 3.6rem;\n        margin-right: 1rem;\n        border-radius: 50%;\n        overflow: hidden;\n\n        @media (max-width: 1368px) {\n          width: 3rem;\n          height: 3rem;\n        }\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n\n  &__pagination {\n    padding-top: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: $secondary3;\n\n    @media (max-width: 767px) {\n      padding-top: 1.5rem;\n      flex-direction: column-reverse;\n      gap: 1.5rem;\n    }\n  }\n}\n\n.common_table {\n  color: transparent;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$baseFont: \"Poppins\", sans-serif;\n$baseFont2: \"Krona One\", sans-serif;\n\n$white: #ffffff;\n$black: #000000;\n$primary: #6d8afa;\n$primary2: #6f86de;\n$lightGray: #bdbdbd;\n$lightGray2: #d1d1d1;\n$secondary: #252a3a;\n$secondary2: #232323;\n$secondary3: #a3a3a3;\n$secondary4: #727272;\n$secondary5: #292c2e;\n$secondarybg: #171b27;\n$secondarybg2: #22283a;\n$secondarybg3: #202535;\n$secondarybg4: #172545;\n$borderClr: #262626;\n$borderClr2: #252525;\n$borderClr3: #28343e;\n\n$green: #7bbb3f;\n$blue: #2797d1;\n$red: #c3292d;\n$orange: #f68630;\n$skyblue: #01cde4;\n$yellowdark: #fbbb10;\n$reddark: #e54c40;\n\n$btnGradient: linear-gradient(270deg, #fde679 -0.16%, #f26c33 86.5%);\n\n$gradient: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);\n$gradient2: linear-gradient(0deg, rgba(0, 0, 0, 0) -29.92%, #161616 97.38%);\n$gradient3: linear-gradient(90deg, #fde076 1.57%, rgba(242, 107, 51, 0) 101.1%);\n$gradient4: linear-gradient(261.01deg, #212122 2.84%, rgba(0, 0, 0, 0) 165.67%);\n\n$boxShadow: 0 1.2rem 1.6rem -0.4rem rgba(255, 255, 255, 0.2),\n  0 0.4rem 0.6rem -0.2rem rgba(255, 255, 255, 0.15);\n$boxShadow2: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);\n$boxShadow3: inset 3px 17px 37px rgba(3, 3, 3, 0.6),\n  inset 0px 0px 5px rgba(255, 255, 255, 0.1);\n\n// z indexes\n$header: 988;\n$sidebar: $header + 3;\n$sidebar_overlay: $sidebar - 2;\n$modal: 1056;\n$loader: 1090;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
